import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { environment } from './../../../environments/environment';
import { enpointCervinoWeb } from './../../configuration/enpointsCervino';
import { WayToPayModel } from './../../models/management/way-to-pay-model';

@Injectable({
  providedIn: 'root'
})
export class WayToPayService {

  constructor(private _httpClient: HttpClient) { }

  createWayToPay(wayToPayModel: WayToPayModel): Observable<WayToPayModel> {
    return this._httpClient.post<WayToPayModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.wayToPay.CreateWayToPay}`,
      wayToPayModel
    );
  }

  deleteWayToPay(wayToPayId: number): Observable<WayToPayModel> {
    return this._httpClient.delete<WayToPayModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.wayToPay.DeleteWayToPay}/${wayToPayId}`);
  }

  exportGeneralConsultation(filters: ColumnResponseModel[], columnSort: string | null, ascendant: boolean): Observable<Blob> {
    const params = new HttpParams().set('columnSort', columnSort ?? '').set('ascendant', ascendant.toString());
    return this._httpClient.post(`${environment.apiCervinoBackend}${enpointCervinoWeb.wayToPay.ExportGeneralConsultation}`, filters, {
      params,
      responseType: 'blob',
    });
  }

  getAllWayToPay(): Observable<Array<WayToPayModel>> {
    return this._httpClient.get<Array<WayToPayModel>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.wayToPay.GetAllWayToPay}`)
  }

  getAllWayToPaysWithPagination(page: number, limit: number, columnSort: string | null, ascendant: boolean, filters: ColumnResponseModel[]): Observable<PagedResponseModel<any>> {
    const params = new HttpParams().set('page', page).set('limit', limit).set('columnSort', columnSort || '').set('ascendant', ascendant);
    return this._httpClient.post<PagedResponseModel<any>>(`${environment.apiCervinoBackend}${enpointCervinoWeb.wayToPay.GetAllWayToPaysWithPaginationAsync}`,
      filters, { params: params }
    );
  }

  getColumnsForGeneralConsultation(): Observable<ColumnResponseModel[]> {
    return this._httpClient.get<ColumnResponseModel[]>(`${environment.apiCervinoBackend}${enpointCervinoWeb.wayToPay.GetColumnsForGeneralConsultationAsync}`);
  }

  getFirstIncomeConceptByKeys(): Observable<WayToPayModel> {
    return this._httpClient.get<WayToPayModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.wayToPay.GetFirstWayToPayByKeysAsync}`);
  }

  getLastIncomeConceptByKeys(): Observable<WayToPayModel> {
    return this._httpClient.get<WayToPayModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.wayToPay.GetLastWayToPayByKeysAsync}`);
  }

  getNextIncomeConceptByKeys(code: number): Observable<WayToPayModel> {
    const params = new HttpParams().set('code', code);
    return this._httpClient.get<WayToPayModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.wayToPay.GetNextWayToPayByKeysAsync}`,
      { params: params }
    );
  }

  getPreviusIncomeConceptByKeys(code: number): Observable<WayToPayModel> {
    const params = new HttpParams().set('code', code);
    return this._httpClient.get<WayToPayModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.wayToPay.GetPreviusWayToPayByKeysAsync}`,
      { params: params }
    );
  }

  getWayToPayByCode(code: number): Observable<WayToPayModel> {
    return this._httpClient.get<WayToPayModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.wayToPay.GetWayToPayByCode}/${code}`)
  }

  getWayToPayById(wayToPayId: number): Observable<WayToPayModel> {
    return this._httpClient.get<WayToPayModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.wayToPay.GetWayToPayById}/${wayToPayId}`)
  }

  updateWayToPay(wayToPayModel: WayToPayModel): Observable<WayToPayModel> {
    return this._httpClient.put<WayToPayModel>(`${environment.apiCervinoBackend}${enpointCervinoWeb.wayToPay.UpdateWayToPay}`,
      wayToPayModel
    );
  }
}
